
export default function Loading() {
  return <div className="flex flex-row pt-48 justify-center w-100">
    <div className="loader"></div>
  </div>;
}